<template>
  <div class="comList">
    <div class="comList_item mb-1 padding-1" v-for="(item, index) in list" :key="index" @click="$emit('click', item)">
    
      <div class="comList_item_left">
       <div class="comList_center">
        <div class="comList_item_left_icon mr-0" v-if="item.leftIcon">
        <img :src="item.leftIcon" alt="">
      </div>
        <div :class="['comList_item_left_title' , item.label?'mb-0':'']" v-if="item.title">
          <span :class="[showEyes?'mr-0':'']">{{ item.title }}</span>
          <img v-if="item.visibility && showEyes" src="@/assets/image/Miracle/eyeopen.png" @click.stop="item.visibility =!item.visibility" alt="">
          <img v-if="!item.visibility && showEyes" src="@/assets/image/Miracle/eyeclose.png" @click.stop="item.visibility =!item.visibility" alt="">
        </div>
       </div>
        <div :class="['comList_item_left_label' , isNaN(item.label)?'':'comList_item_left_label_nmber',showEyes?'comList_item_left_label_nmber':'']" v-if="item.label">
          <span v-if="item.visibility || !showEyes">{{ item.label }}</span>
          <span v-else>********</span>
        </div>
      </div>
      <div class="comList_item_right" >
        <div
          :class="['comList_item_right_text' , item.rightIcon?'mr-0':'']"
          :style="{ color: rightColor }"
          v-if="item.rightText"
        >
          {{ item.rightText }}
        </div>
        <div
          class="comList_item_right_icon" 
          v-if="item.rightIcon"
        >
          <img :src="item.rightIcon" alt="" />
         
        </div>
      </div>
    </div>
    <van-empty v-if="!list.length"></van-empty>
  </div>
</template>

<script>
export default {
  name: "ComList",
  props: {
    rightColor: {
      type: String,
      default: "",
    },
    showEyes: { // 是否展示小眼睛
      type: Boolean,
      default: false,
    },
    list: {
      type: Array,
      default: () => [],
    },
    // 使用小眼睛需传入 showEyes为true
    // list所有值都可以同时传入或者个边不传，不会影响使用，不同值组合为不同样式
    // list : [
    //   {
    //     title: "标题",
    //     label: "内容",
    //     rightText: "右侧内容",
    //     rightIcon: "右侧icon 传入使用require引入图片",
    //     visibility: '默认传入true 用于控制label是否显示为密文',
    //     leftIcon: "左侧icon 传入使用require引入图片"
    //   }
    // ]
  },
  data() {
    return {
    };
  },
  methods: {},
};
</script>

<style lang="scss" scoped>
@import "./index.scss";
</style>